// ─────────────────────────────────────────────────────────────
// STATION CONFIG — the one place the owner updates station details.
// Paste real values here when ready; `null` keeps a clearly-labeled
// placeholder on the site. Nothing here is live until configured.
// ─────────────────────────────────────────────────────────────

export const STATION = {
    name: "MyRadio1st Presents: Inspiration Station",
    tagline: "Good Music. Good Energy. No Gatekeeping.",

    // Live365 official player embed URL (from your Live365 dashboard).
    // Example shape: "https://live365.com/embed/..." — paste yours here.
    live365EmbedUrl: null,

    // Donation checkout link (Stripe Payment Link, Ko-fi, Buy Me a Coffee, etc).
    // While null, the donation panel runs in clearly-labeled preview mode.
    donationCheckoutUrl: "https://ko-fi.com/mr1radio",

    // Official music submission destination (Google Form). Opens in a new tab.
    musicSubmissionFormUrl: "https://forms.gle/zYaVUdqnRgxvuipr8",

    // Social profiles — paste real URLs to activate the cards.
    socials: [
        { id: "instagram", name: "Instagram", url: "https://www.instagram.com/myradio1st" },
        { id: "tiktok", name: "TikTok", url: "https://www.tiktok.com/@yo_sn00ze" },
        { id: "facebook", name: "Facebook", url: "https://www.facebook.com/inspirationstationfm" },
        { id: "x", name: "X (Twitter)", url: null },
        { id: "youtube", name: "YouTube", url: null },
    ],
};

export const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -76 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
